var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4033 15L20.3314 11.072C20.5178 10.8859 20.6227 10.6334 20.6229 10.3699C20.6231 10.1065 20.5187 9.85382 20.3326 9.6674C20.1465 9.48097 19.894 9.37611 19.6306 9.37588C19.3672 9.37564 19.1144 9.48006 18.928 9.66615L15 13.5942L11.072 9.66615C10.8856 9.47973 10.6327 9.375 10.3691 9.375C10.1054 9.375 9.85258 9.47973 9.66615 9.66615C9.47973 9.85258 9.375 10.1054 9.375 10.3691C9.375 10.6327 9.47973 10.8856 9.66615 11.072L13.5942 15L9.66615 18.928C9.47973 19.1144 9.375 19.3673 9.375 19.6309C9.375 19.8946 9.47973 20.1474 9.66615 20.3338C9.85258 20.5203 10.1054 20.625 10.3691 20.625C10.6327 20.625 10.8856 20.5203 11.072 20.3338L15 16.4058L18.928 20.3338C19.1144 20.5203 19.3673 20.625 19.6309 20.625C19.8946 20.625 20.1474 20.5203 20.3338 20.3338C20.5203 20.1474 20.625 19.8946 20.625 19.6309C20.625 19.3673 20.5203 19.1144 20.3338 18.928L16.4033 15Z",
    fill: "#919BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.4bf6796c9905d26b48ac7f4364199a8f.svg";
export { ForwardRef as ReactComponent };